﻿import React from 'react';
import {connect} from 'react-redux';

import {DynamicFormCustomForm} from '../../../DynamicForms/Styles/dynamicFormStyles';
import DynamicFormQuestionGroup from '../../../DynamicForms/Components/DynamicFormQuestionGroup';

import HealthDeclarationHeading from './HealthDeclarationHeading';
import HealthDeclarationQuestionTypeHandler from './HealthDeclarationQuestionTypeHandler';

import {
    updateHealthDeclarationStatusAction,
    registerVirtualPageViewAction,
    addQuestionGroupsQuestionsAction,
    repeatQuestionGroupAction,
    removeRepeatedQuestionGroupAction,
    removeQuestionGroupsQuestionsAction
} from '../State/actions';

import Accordion from '../../../UI/Accordion';

class HealthDeclarationStepOne extends React.Component {
    componentDidMount() {
        // in case we've loaded a saved hd draft with all input fields valid
        // the status has to updated in order to reflect this (=> enabling the continue button)
        this.props.updateHealthDeclarationStatus();

        // send virtual page view to gtm/mtm / ga
        this.props.registerVirtualPageView();
    }

    render() {
        const healthFormData = this.props.data.healthFormData;

        return (
            <div>
                <Accordion
                    title={<HealthDeclarationHeading/>}
                    unexpandable={true}
                    hideOverflow={false}
                    noBackground={true}
                    noHeaderPadding={true}
                    headerComponent={
                        <DynamicFormCustomForm
                            id="healthDeclarationForm"
                            onSubmit={e => e.preventDefault()}
                        >
                            {healthFormData.questionGroups.map(group => (
                                <DynamicFormQuestionGroup
                                    key={group.id}
                                    questionGroup={group}
                                    questionTypeHandler={HealthDeclarationQuestionTypeHandler}

                                    formInputs={this.props.formInputs}
                                    repeatedInputs={this.props.repeatedInputs}

                                    repeatQuestionGroup={this.props.repeatQuestionGroup}
                                    removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                                    addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                    removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                                />))
                            }
                        </DynamicFormCustomForm>
                    }
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.healthDeclarationPageData,
        formInputs: state.healthDeclarationFormInputs,
        repeatedInputs: state.healthDeclarationRepeatedInputs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateHealthDeclarationStatus: () => dispatch(updateHealthDeclarationStatusAction()),
        registerVirtualPageView: () => dispatch(registerVirtualPageViewAction()),
        repeatQuestionGroup: (questionGroup) => dispatch(repeatQuestionGroupAction(questionGroup)),
        removeRepeatedQuestionGroup: (questionGroup, index) => dispatch(removeRepeatedQuestionGroupAction(questionGroup, index)),
        addQuestionGroupInputs: (...args) => dispatch(addQuestionGroupsQuestionsAction(...args)),
        removeQuestionGroupInputs: (...args) => dispatch(removeQuestionGroupsQuestionsAction(...args)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthDeclarationStepOne);
